import { useState } from 'react';
import { getCurrentLocale } from '@ardoq/locale';
import { isArdoqError, toArdoqError } from '@ardoq/common-helpers';
import { imagePreviewApi } from '@ardoq/api';
import * as reducers from './reducers';
import { ImagePreviewErrorMessages } from './types';

const DEFAULT_FETCH_FAILED_MESSAGE = 'Failed to fetch image';

export const useImagePreview = (errorMessages?: ImagePreviewErrorMessages) => {
  const locale = getCurrentLocale();
  const [state, setState] = useState({
    ...reducers.getInitialState(locale),
  });

  const fetchFailedMessage =
    errorMessages?.fetchFailedMessage ?? DEFAULT_FETCH_FAILED_MESSAGE;

  const onFetchImage = async (url: string) => {
    setState(currentState => reducers.setLoadingState(currentState));

    try {
      const response = await imagePreviewApi.fetchImagePreview(url);

      if (isArdoqError(response)) {
        setState(currentState =>
          reducers.setFetchImageError(
            currentState,
            response,
            errorMessages?.errorTitle
          )
        );
        return;
      }

      setState(currentState =>
        reducers.setFetchImageSuccess(currentState, response)
      );
    } catch (error) {
      setState(currentState =>
        reducers.setFetchImageError(
          currentState,
          toArdoqError({
            userMessage: fetchFailedMessage,
            error:
              error instanceof Error ? error : new Error(fetchFailedMessage),
          }),
          errorMessages?.errorTitle
        )
      );
    }
  };

  const commands = {
    onFetchImage,
    onChangeBackgroundColor: (backgroundColor: string) =>
      setState(currentState =>
        reducers.setBackgroundColor(currentState, backgroundColor)
      ),
  };

  return { commands, state };
};
